/*
62 車體甲式代車費日額型
 */
const state = () => ({
    name: '',
    qDay: { text: null, value: null },
    validData: {
        // api-13 GetValidInsAndCovers 取回的資料(在保費試算過後要清除此資料)
        InsCategory: 'Car',
        InsType: null,
        InsName: '',
        InsClass: '',
        IsAdditionalIns: false,
        IsAllowEC: true,
        DisabledDate: null,
        OrderIndex: null,
        Covers: [],
        OnlyPartner: false,
    },
    selected: false,
    uploadForm: {
        InsType: '62',
        InjuredCover: 0,
        DeathCover: 0,
        DamageCover: 0,
        Deduct: 0,
        QDay: 0,
        Provision: null,
        InsScope: '',
        RemedyDailyPay: 1000,
    },
});

const actions = {
    /**
     * 刪掉使用者相關資料，保留險種選項資料 - 使用時機如：登出、結帳完成
     * - 清空試算過的險種選項資料
     * - 清空 api 回傳的險種內容資料
     */
    clearUserData(context) {
        context.commit('clearValidData');
        context.commit('clearUploadForm');
    },
};

const getters = {
    /**
     * 可選擇的保額選項
     *
     * @param {*} state
     * @returns
     */
    qDayOptionsValid: (state) => {
        return state.validData.Covers.filter((o) => {
            return o.AmountCode === 'QDay';
        }).map((o) => {
            return { text: o.AmountCaption, value: o.AmountValue };
        });
    },
};

const mutations = {
    /**
     * 選擇險種
     *
     * @param {*} state
     * @param {*} payload
     */
    select(state, payload) {
        state.selected = payload;
    },
    /**
     * 設定資料
     *
     * @param {*} state
     * @param {*} payload
     */
    setData(state, payload) {
        state.data = payload;
    },
    /**
     * 可選擇的險種
     *
     * @param {*} state
     * @param {*} payload
     */
    setValidData(state, payload) {
        state.validData = payload;
    },
    /**
     * 險種名稱
     *
     * @param {*} state
     * @param {*} payload
     */
    setName(state, payload) {
        state.name = payload;
    },
    /**
     * 保額選項
     *
     * @param {*} state
     * @param {*} payload
     */
    setQDay(state, payload) {
        state.qDay = payload;
        state.uploadForm.QDay = payload.value;
    },
    /**
     * 儲存保險資料進 store
     *
     * @param {*} state
     * @param {*} payload
     */
    setUploadForm(state, payload) {
        state.uploadForm = payload;
    },
    /**
     * UploadForm 是call API-2 所需上傳的資料，此功能為設定 UploadForm 中的單個欄位值
     * @param {*} state
     * @param {*} payload
     */
    setUploadFormValue(state, payload) {
        state.uploadForm[payload.key] = payload.value;
    },
    /**
     * 清空試算過的險種選項資料
     *
     * @param {*} state
     */
    clearValidData(state) {
        state.validData = {
            InsCategory: 'Car',
            InsType: null,
            InsName: '',
            InsClass: '',
            IsAdditionalIns: false,
            IsAllowEC: true,
            DisabledDate: null,
            OrderIndex: null,
            Covers: [],
            OnlyPartner: false,
        };
    },
    /**
     * 清空 api 回傳的險種內容資料
     *
     * @param {*} state
     */
    clearUploadForm(state) {
        state.uploadForm = {
            InsType: '62',
            InjuredCover: 0,
            DeathCover: 0,
            DamageCover: 0,
            Deduct: 0,
            QDay: 0,
            Provision: null,
            InsScope: '',
            RemedyDailyPay: 1000,
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
